import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { CSVLink } from 'react-csv';
// eslint-disable-next-line import/extensions
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import qDocPromise from 'config/qDoc';
import tableDef from '../../tableDef';

import styles from './styles';

class Table extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    searchString: PropTypes.string.isRequired,
    selectedDate: PropTypes.string.isRequired,
    isPartner: PropTypes.bool,
  }


  static defaultProps = {
    isPartner: false,
  };

  state = {
    qMatrix: [],
    currency: '',
  }

  componentDidMount() {
    this.createQObject();
  }

  componentWillUnmount() {
    this.destroyQObject();
  }

  createQObject = async () => {
    const qDoc = await qDocPromise;
    this.qObject = await qDoc.createSessionObject(tableDef);
    this.qObject.on('changed', this.updateQMatrix);
    this.updateQMatrix();
  }

  destroyQObject = async () => {
    const qDoc = await qDocPromise;
    qDoc.destroySessionObject(this.qObject.id);
  }

  updateQMatrix = async () => {
    const layout = await this.qObject.getLayout();
    this.setState({ qMatrix: layout.qHyperCube.qDataPages[0].qMatrix, currency: layout.currency });
  }

  handleSelection = qElemNumber => async () => {
    this.qObject.selectHyperCubeValues('/qHyperCubeDef', [qElemNumber], true);
  }


  handleXlsxExport = () => {
    const { qMatrix, currency } = this.state;
    const { searchString, selectedDate } = this.props;

    // Filter the qMatrix as done in the render method
    const filteredQMatrix = qMatrix.filter(row =>
      row
        .reduce((arr, col) => [...arr, col.qText], [])
        .some(item => item.toLowerCase().includes(searchString.toLowerCase())));

    // Define headers (same as for CSV)
    const headers = ['SKU No', 'Type', 'Product', 'Product Description', 'License Meter', 'Unit', currency];

    // Format each row: if the cell text is '0' or '-1', then show an empty string
    const dataRows = filteredQMatrix.map(row =>
      row.map(cell => (cell.qText === '0' || cell.qText === '-1' ? '' : cell.qText)));

    // Combine header and data rows
    const wsData = [headers, ...dataRows];

    // Create a worksheet from the array of arrays
    const worksheet = XLSX.utils.aoa_to_sheet(wsData);

    // Create a new workbook and append the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Create a filename similar to the CSV export, but with .xlsx extension
    const fileName = `Pricelist-${selectedDate}-${currency}.xlsx`;

    // Write the workbook to a file (this triggers the file download)
    XLSX.writeFile(workbook, fileName);
  };

  render() {
    const {
      classes, searchString, selectedDate, isPartner,
    } = this.props;
    const { qMatrix, currency } = this.state;

    const skusToHideForPartners = ['Q501010E', 'Q501021E', 'Q501022E', 'Q501031E'];

    // const filteredQMatrix = qMatrix.filter(row => row.reduce((arr, col) => [...arr, col.qText], []).some(item => item.toLowerCase().includes(searchString.toLowerCase())));

    const filteredQMatrix = qMatrix.filter((row) => {
      // Filter out rows with the specified SKUs when isPartner is true
      if (isPartner) {
        const sku = row[0] && row[0].qText ? row[0].qText : '';
        if (skusToHideForPartners.includes(sku)) return false;
      }
      // Continue with search string filtering
      return row.reduce((arr, col) => [...arr, col.qText], [])
        .some(item => item.toLowerCase()
          .includes(searchString.toLowerCase()));
    });


    // Prepare CSV headers and data
    // Here, we create an array where the first row is the header row
    const csvHeaders = ['SKU No', 'Type', 'Product', 'Product Description', 'License Meter', 'Unit', currency];

    // Convert each row in filteredQMatrix into an array of strings
    const csvDataRows = filteredQMatrix.map(row =>
      row.map(cell =>
        ((cell.qText === '0' || cell.qText === '-1') ? '' : cell.qText)));


    // Combine header and rows for CSV export
    const csvExportData = [csvHeaders, ...csvDataRows];

    const fileName = `Pricelist-${selectedDate}-${currency}.csv`;

    return (
      <div className={classes.container}>
        {/* CSV Export Button */}
        <div style={{
              marginLeft: 'auto', textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px',
              }}
        >
          <span>Export: </span>
          <CSVLink
            data={csvExportData}
            filename={fileName}
            target="_blank"
            style={{ display: 'block' }}
          >
            <button type="button" className={classes.csvExportBtn}>
              <img src="assets/csv-export.png" alt="export to csv" className={classes.csvExportImg} />
            </button>
          </CSVLink>
          <button type="button" className={classes.csvExportBtn} onClick={this.handleXlsxExport}>
            <img src="assets/xls-export.png" alt="export to xlsx" className={classes.csvExportImg} />
          </button>
        </div>
        <div className={classes.tableWrapper}>
          {filteredQMatrix.length === 0 && <div className={classes.noResults}>No results</div>}
          {filteredQMatrix.length > 0 && (
          <table className={classes.table}>
            <thead>
              <tr>
                <th className={classes.th}>SKU No</th>
                <th className={classes.th}>Type</th>
                <th className={classes.th}>Product</th>
                <th className={classes.th}>Product Description</th>
                <th className={classes.th}>License Meter</th>
                <th className={classes.th}>Unit</th>
                <th className={classes.th} style={{ textAlign: 'right', paddingRight: '1em' }}>{currency}</th>
              </tr>
            </thead>
            <tbody>
              {filteredQMatrix.map((row, i) => (
                <tr
                  key={row.reduce((key, col) => key + col.qElemNumber, '')}
                  style={{ background: i % 2 === 0 ? '#fff' : '#F2F3F7' }}
                >
                  {row.map((col, j) => (
                    // eslint-disable-next-line
                    <td key={j} className={classes.td} style={{textAlign: j === 6 ? 'right' : 'left'}}>{(col.qText == '0' || col.qText == '-1') ? '' : col.qText}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
        </div>
        <div className={classes.tableFooter}>
          <p>
          Number of items: {filteredQMatrix.length}
          </p>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Table);
